module.exports = __webpack_public_path__ + "img/4.23ea84a7.jpg";